import type { Dispatch, SetStateAction } from "react";
import type { FooterTerminalLine } from "./use-footer-terminal";

type SetHistory = Dispatch<SetStateAction<FooterTerminalLine[]>>;

export function runFooterDesktopUpdate(setHistory: SetHistory): void {
  const append = (text: string) =>
    setHistory((history) => [...history, { type: "output", text }]);
  if (!window.electron?.checkForUpdate) {
    append("Not running in Electron, use external terminal: fintheon update");
    return;
  }
  window.electron
    .checkForUpdate()
    .then(async (result) => {
      if (!result.ok) {
        append("Update check failed, open the latest GitHub release manually.");
        return;
      }
      if (!result.updateAvailable || !result.latest) {
        append("Already up to date.");
        return;
      }
      append(`Update available: ${result.latest}. Downloading now...`);
      const download = await window.electron?.downloadUpdate?.(result.latest);
      if (!download?.ok) {
        append(
          `Update download failed, ${download?.reason ?? "try again from an external terminal"}.`,
        );
        return;
      }
      const install = await window.electron?.installUpdate?.(result.latest);
      append(
        install?.ok
          ? "Installer starting. Fintheon will relaunch after the update."
          : `Install handoff failed, ${install?.reason ?? "try again from an external terminal"}.`,
      );
    })
    .catch(() =>
      append(
        "Update check failed, try again from an external terminal: fintheon update",
      ),
    );
}
